import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { withRouter } from 'react-router';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';

export class LinkToConvenio extends Component {
  static propTypes = {
    id: PropTypes.number,
    numero: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ano: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nomeBeneficiario: PropTypes.string,
    history: PropTypes.object,
    isIntegradoOxy: PropTypes.bool
  };

  handleClick = () => {
    const { id, numero, ano, history } = this.props;
    const { entidade } = StorageService.getItem('userInfo');
    history.push(
      `/convenios/detalhes?entidade=${entidade.id}&id=${id}&nrConvenio=${numero}&nrAnoConvenio=${ano}`
    );
  };

  render() {
    const { id, numero, ano, nomeBeneficiario, isIntegradoOxy } = this.props;
    const beneficiarioText = nomeBeneficiario ? ` ${nomeBeneficiario}` : '';

    if (!numero || !ano || !id || !isIntegradoOxy) {
      return `${numero ?? ''}/${ano ?? ''}${beneficiarioText}`;
    }

    return (
      <>
        <a style={{ cursor: 'pointer' }} onClick={this.handleClick}>
          {`${numero}/${ano}`}
        </a>
        {beneficiarioText}
      </>
    );
  }
}

export default withRouter(LinkToConvenio);
